import React, { Component } from 'react';
import { Alert, Form, FormGroup, Label, Input, Button, FormFeedback } from 'reactstrap';
import '../../pages/login/Login.css';
import { validatePassword } from './../../utils/validations';

class ChangePasswordUI extends Component {

  constructor(props) {
    super(props);
    this.state = {
      confirmPassword: {
        value: null,
        error: false
      },
      password: {
        value: null,
        error: false
      }
    }
  }

  handlePasswordChange = ({ target }) => {
    const { value } = target;
    const { password } = this.state;
    password.value = value;
    password.error = false;
    this.setState({
      password
    });
  }

  handleConfirmPasswordChange = ({ target }) => {
    const { value } = target;
    const { confirmPassword } = this.state;
    confirmPassword.value = value;
    confirmPassword.error = false;
    this.setState({
      confirmPassword
    });
  }

  handleUpdatePassword = () => {
    const password = this.state.password.value;
    const confirmPassword = this.state.confirmPassword.value;
    const isValidPassword = validatePassword(password);
    if (!isValidPassword) {
      this.setState({
        password: {
          value: password,
          error: !isValidPassword,
        }
      })
    } else if (isValidPassword && (password !== confirmPassword)) {
      this.setState({
        confirmPassword: {
          value: confirmPassword,
          error: true
        }
      })
    } else if (isValidPassword && password === confirmPassword) {
      this.props.onSubmitPassword(password);
    }
  }

  render() {
    let alert = null;
    if (this.props.errorMessage) {
      alert = (
        <div className="alert-msg-bg mt50">
          <i className="close-icon">close</i>
					<div className="d-flex custom-message-box">
						<i className="material-icons alert-icon-bg">remove_circle</i>
						<span className="ml10 alert-msg-text">{this.props.errorMessage}</span>
					</div>
				</div>)
    }
    let desc = null;
    if (this.props.desc) {
      desc = (<div className="text-left mt10 change-password-desc">
        Your current password is a temporary password. Please change this Password to a more secure one.
    </div>)
    }
    let passwordFeedback = null;
    if (this.state.confirmPassword.value == null || !this.state.confirmPassword.value) {
      passwordFeedback = <FormFeedback>Please enter a valid password</FormFeedback>
    } else {
      passwordFeedback = <FormFeedback>The new passwords you entered do not match. Please re-enter.</FormFeedback>
    }
    return (
      <div>
         {alert}
        <div className="text-left mt30 change-password-title">
          {this.props.title}
        </div>
        {desc}
        <Form className={(alert==null) ? "mt30": "mt10"}>
          <FormGroup>
            <Label for="password" className="label-login-password mb10">New Password</Label>
            <div className="inner-addon right-addon">
            <Input
              type="password"
              name="password"
              id="password"
              className="inputBox-height"
              onChange={this.handlePasswordChange}
              invalid={this.state.password.error}
            />
            <FormFeedback>Please provide your new password.</FormFeedback>
            </div>
            
          </FormGroup>
          <FormGroup className="mt25">
            <Label for="confirmPassword" className="label-login-password mb10">Confirm Password</Label>
            <div className="inner-addon right-addon">
            <Input
              type="password"
              name="confirmPassword"
              id="confirmPassword"
              className="inputBox-height"
              onChange={this.handleConfirmPasswordChange}
              invalid={this.state.confirmPassword.error}
            />
            {passwordFeedback}
            </div>    

          </FormGroup>
          <div className="text-center mt30 update_password_btn_container">
            <Button onClick={this.handleUpdatePassword} className="btn-update-password"><span className="txt-update-password">Update Password</span></Button>
          </div>
        </Form>
      </div>
    )
  }
}

export default ChangePasswordUI;